import { ApiType } from "@gymflow/common";

export async function memberSearchByFullNameQueryFn({
  api,
  searchTerm,
  page,
  limit,
}: {
  api: ApiType;
  searchTerm: string;
  page: number;
  limit: number;
}) {
  const result = await api.memberApi.findByFullName(searchTerm, {
    page,
    limit,
  });
  return result.data;
}
